import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";

function Loading() {
	return (
		<div className="breadcrumb__loader">
			<DotSpinner color="#1cc2ff" />
		</div>
	);
}
const AustraliaTinyMapLoader = Loadable.Map({
	loader: {
		Breadcrumb: () => import(/* webpackChunkName: "tinyMap" */ "components/Breadcrumb"),
		baseIcon: () => import(/* webpackChunkName: "tinyMap" */ "lib/maps/tinyAustralia.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const { actions } = props;
		const Breadcrumb = loaded.Breadcrumb.default;
		const baseIcon = loaded.baseIcon.default;
		return (
			<Breadcrumb
				baseIcon={baseIcon}
				stateName={props.stateName}
        changeMap={actions.changeMap}
        mapId="Australia"
        mapStateIdPrefix="AU"
        nameTop="32px"
        nameLeft="2px"
        invert
			/>
		);
	},
});

export default AustraliaTinyMapLoader;